import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=3e69b86e&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=3e69b86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e69b86e",
  null
  
)

export default component.exports